import BodyPassword from "../account/BodyPassword";
import Layout from "../Layout";
import HeaderAccount from "../account/HeaderAccount";
import useUserStore from "../../utils/storeApp";

const ChangePasswordMain = () => {
  const { userRole } = useUserStore((state) => ({
    userRole: state.userRole,
  }));

  return (
    <Layout>
      {userRole === "SES ADMINISTRATOR" ||
      userRole === "ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR" ? (
        <HeaderAccount />
      ) : null}
      <section className="layout-container" aria-labelledby="changePasswordHeading">
        <div className="container">
          <div className="descript-container">
            <h1 className="form-title g-clr" id="changePasswordHeading">Change Password</h1>
            <p>
                Enter your current password if it hasn't been entered already, then update your password to meet all the required criteria.
            </p>
          </div>
          <BodyPassword />
        </div>
      </section>
    </Layout>
  );
};

export default ChangePasswordMain;
